<template>
  <v-select
    v-model="meetingAddress"
    @change="setMeetingAddress"
    :label="$t('appointment.formCreate.labels.meetingAddress')"
    :readonly="meetingAddressesLength < 2"
    :items="appointmentFields.realties_complete"
    :rules="rules"
    ref="meetingAddress"
    item-text="address"
    item-value="id"
    return-object
    outlined
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'MeetingAddress',

  props: {
    rules: {
      type: Array,
    },
  },

  watch: {
    appointmentFields({ realties_complete }) {
      const addressId = realties_complete[0]?.id
      this.meetingAddress = addressId ? addressId : null
    },
  },

  computed: {
    ...mapGetters(['realties', 'appointmentFields']),

    meetingAddress: {
      get() {
        return this.appointmentFields?.realties_complete[0]?.id
      },
      set(newValue) {
        return newValue
      },
    },

    meetingAddressesLength() {
      return this.appointmentFields.realties.length
    },

    showHint() {
      if (this.meetingAddressesLength >= 1) return
      return $t('appointment.formCreate.hints.meetingAddress')
    },
  },

  methods: {
    ...mapActions(['showErrorMessage']),
    ...mapMutations(['setAppointmentFields']),

    setMeetingAddress(location) {
      const { meeting_location_options } = this.appointmentFields

      this.setAppointmentFields({
        meeting_location_options: {
          ...meeting_location_options,
          id: location.id,
        },
      })

      this.setAppointmentFields({
        meeting_location_address: location.address,
      })
    },
  },
}
</script>
